{
  "back": "Retour",
  "noSongsTitle": "Aucune chanson dans la liste de lecture",
  "noSongsDescription": "Cette liste de lecture ne contient aucune chanson.",
  "notFoundTitle": "Liste de lecture introuvable",
  "notFoundDescription": "Nous n'avons pas trouvé cette liste de lecture."
}
